module.exports = __webpack_public_path__ + "img/icon95.035d611a.png";